import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as namesService from "../services/namesService";

export function useNamesQuery(groupId) {
  return useQuery({
    queryKey: ["names", groupId],
    queryFn: () => namesService.fetchNames(groupId),
    enabled: !!groupId,
  });
}

export function useAddName(groupId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: namesService.addName,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["names", groupId] }),
  });
}

export function useRenameName(groupId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: namesService.renameName,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["names", groupId] }),
  });
}

export function useDeleteName(groupId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: namesService.deleteName,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["names", groupId] }),
  });
}
